import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconPaths } from '../../../../../../../_metronic/helpers/enumsUI'
import { showAlert } from '../../../../../../../_metronic/helpers/AlertHelper'
import { RowActions } from '../../../../../../components/Table/TableCells'
import { ProtocoloLinha } from '../../../core/_models'
import { useCriarRascunho } from '../../../acoes/useCriarRascunho'

type Props = {
  versao: ProtocoloLinha
  idEmpresa?: number
  podeCriarRascunho: boolean
}

/**
 * Ações da versão: a lupa abre o detalhe; no "⋯", criar rascunho a partir da versão (só das
 * substituídas, e só para quem pode criar rascunho).
 */
export const ProtocoloAcoesCell: FC<Props> = ({ versao, idEmpresa, podeCriarRascunho }) => {
  const navigate = useNavigate()
  const { confirmarECriar } = useCriarRascunho({
    escopo: 'versao',
    idEmpresa,
    idOrigem: versao.id,
  })

  const criarRascunho = async () => {
    const erro = await confirmarECriar()
    if (erro) showAlert({ title: 'Não foi possível criar o rascunho', text: erro, icon: 'error' })
  }

  return (
    <RowActions
      itemName={`versão ${versao.versao}`}
      primaryAction={{
        label: 'Ver detalhe',
        onClick: () => navigate(`/apps/protocolos-triagem/${versao.id}?empresa=${idEmpresa}`),
        icon: IconPaths.Search,
      }}
      items={[
        {
          label: 'Criar rascunho a partir desta',
          onClick: criarRascunho,
          hidden: !(podeCriarRascunho && versao.situacao === 'SUBSTITUIDO'),
        },
      ]}
    />
  )
}
